import { UpcomingMovieListWrapper } from "../../Styles/MovieStyle";

const UpcomingMoviesPage = () => {
    return (
        <>
            <UpcomingMovieListWrapper>
                <div className="page_content">
                    <div className="page_head">
                        <h3>Upcoming <span><b>M</b>ovies</span></h3>
                    </div>
                    <div className="page_items">
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                        <div className="movie_box">
                            <div className="box_inner">
                                <div className="image_box">
                                    <img src="/images/Movie-1.jpg" alt="" />
                                </div>
                                <div className="movie_brief">
                                    <li>
                                        <span><i className="fa-solid fa-star"></i>4.2</span>
                                        <p>[ 5k ratings | 1.5k reviews ]</p>
                                    </li>
                                    <h5>Avatar: The Way of Water</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </UpcomingMovieListWrapper>
        </>
    );
}

export default UpcomingMoviesPage;